import { useLayoutEffect, useRef, useState } from 'react';

/**
 * @template T extends HTMLElement - Target Element Type
 * @param targetRef - Target Element
 * @returns [width: number, height: number]
 */
const useResize = <T extends HTMLElement>(targetRef: React.RefObject<T> | T | null) => {
	const [size, setSize] = useState<[number, number] | null>(null);

	const observerRef = useRef(
		new ResizeObserver((entries) => {
			const { width, height } = entries[0].contentRect;

			setSize([width, height]);
		}),
	);

	useLayoutEffect(() => {
		const observer = observerRef.current;
		const target = targetRef && 'current' in targetRef ? targetRef.current : targetRef;

		if (!target) {
			return () => {};
		}

		observer.observe(target);

		return () => {
			observer.unobserve(target);
		};
	}, [targetRef]);

	return size || [];
};

export { useResize };
